module.exports = {
  googleApiKey: 'AIzaSyAI8NmbF2LDPZJodNjuacfaoWjU3gsRStw'
};



// WEBPACK FOOTER //
// ./src/config/build_const.js